
















































import Component from 'vue-class-component';
import { MasterPage } from '@/components/base/master/master-page';
import LoginLogsCriteriaComponent from '@/containers/account/login-logs/login-logs-criteria.vue';
import * as ent from '@/entities';
import logsApi from '@/api/login-logs.api';
import {whiteLabel} from '@/services/config/config.service';

@Component({
    components: {
        'login-logs-criteria': LoginLogsCriteriaComponent
    }
})
export default class LoginLogsMaster extends MasterPage {
    public initialCriteria: ent.IDictionary<any> = null;

    public items: ent.ILoginLog[] = [];

     protected defaultSort: ent.ISort = {
        field: 'inTime',
        asc: false
    };

    private getLogsModel: ent.IGetLoginLogs = null;

    get IPVisible(): boolean {
        return whiteLabel.IPVisible;
    }

    get colsCount(): number {
        return this.IPVisible ? 4 : 3;
    }

    public created() {
        this.initialCriteria = this.$route.query;
    }

    public getLoginModelChange(model: ent.IGetLoginLogs) {
        this.getLogsModel = model;
        this.search();
    }

    // todo: refactor -> remove dublication
    protected search() {
        let body: ent.IGetLoginLogs = {
            ...this.pageSortParams(),
            ...this.getLogsModel
        };

        // this.total = 0;
        // this.items = [];
        this.loading = true;
        return logsApi
            .list(body)
            .then((response: ent.IPaging<any>) => {
                this.loading = false;
                this.items = response.items;
                if (response.total !== null) {
                    this.total = response.total;
                }
            })
            .catch((err) => console.warn(err));
    }
}
